import { http } from '../services';

class ProjetoService {

    async salvarArquivosApresentacao(codigoProjeto, apresentacao, video, form, onProgresso) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('apresentacao', apresentacao);
            formData.append('video', video);
            formData.append('formId', form.formId);

            const request = new XMLHttpRequest();
            const url = http.getUrl(`/projetos/arquivos-apresentacao/${codigoProjeto}`);
            request.open('POST', url); 

            request.setRequestHeader('CSRF-Token', form.token);
            request.withCredentials = true;

            request.upload.addEventListener('progress', (e) => {
                const percentCompleted = (e.loaded / e.total) * 100;
                onProgresso(percentCompleted);
            });

            request.addEventListener('load', (e) => {
                resolve({
                    body: JSON.parse(request.response),
                    status: request.status,
                });
            });

            request.send(formData);
        });
    }

    projetoForm() {
        return http.get('/projetos/form');
    }

    async getProjetos(subevento, evento, area, pago, tipo) {
        return http.get('/projetos', {
            subevento,
            evento,
            area,
            pago,
            tipo,
        });
    }

    async getCount({ searchIndex, searchText, searchOperator }) {
        return http.get('/projetos/count', {
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    // termoMaior(projeto, autor) {
    //     return http.getUrl('/termo-maior')
    //         +
    //         http.getParamsString({
    //             projeto,
    //             autor,
    //         });
    // }

    getProjeto(codigo) {
        return http.get(`/projetos/publico/${codigo}`);
    }

    getTituloProjeto(titulo, subevento) {
        return http.get('/projetos/titulo', {
            titulo,
            subevento,
        });
    }

    getProjetosAvaliados(avaliador) {
        return http.get(`/projetos-avaliados/${avaliador}`);
    }

    getFaltaAvaliar(avaliador) {
        return http.get(`/falta-avaliar/${avaliador}`);
    }

    getProjetosAutor() {
        return http.get('/projetos-autor', {
        });
    }

    desclassificar(projeto) {
        return http.post('/projetos/desclassificar', projeto);
    }

    async save(projeto, form) {
        const formData = new FormData();
        formData.append('arquivo', projeto.arquivo);
        formData.append('formId', form.formId);
        formData.append('projeto', JSON.stringify(projeto));

        const request = await fetch(http.getUrl('/projetos'), {
            method: 'POST',
            body: formData,
            headers: {
                'CSRF-Token': form.token,
            },
            credentials: 'include',
        });
        return {
            body: await request.json(),
            status: request.status,
        };
    }

    delete(projeto) {
        return http.delete('/projetos', projeto);
    }
}

const projetoService = new ProjetoService();
export default projetoService;
